/**
 * RoadStatusBadge Component
 * Displays status badges for GPS and map-detected roads
 */

import { Badge } from '@mantine/core';
import { IconGps, IconMapPin } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import type { RoadStatusBadgeProps } from '../RoadDisplayField.types';
import { ROAD_DISPLAY_FIELD_CONSTANTS } from '../RoadDisplayField.constants';

export function RoadStatusBadge({ value, roadSource }: RoadStatusBadgeProps) {
  const { t } = useTranslation();

  // Don't render if no value or manual source
  if (!value || !roadSource || roadSource === 'manual') {
    return null;
  }

  if (roadSource === 'gps') {
    return (
      <Badge
        variant="light"
        color="green"
        size={ROAD_DISPLAY_FIELD_CONSTANTS.BADGE.SIZE}
        leftSection={
          <IconGps size={ROAD_DISPLAY_FIELD_CONSTANTS.ICONS.LOADER_SMALL} />
        }
      >
        {t('gps.autoSuggested')}
      </Badge>
    );
  }

  if (roadSource === 'map') {
    return (
      <Badge
        variant="light"
        size={ROAD_DISPLAY_FIELD_CONSTANTS.BADGE.SIZE}
        leftSection={
          <IconMapPin size={ROAD_DISPLAY_FIELD_CONSTANTS.ICONS.LOADER_SMALL} />
        }
      >
        {t('map.selectedFromMap')}
      </Badge>
    );
  }

  return null;
}
